import script from "./AdminLoginView.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLoginView.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLoginView.vue?vue&type=style&index=0&id=ae6a7ce0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae6a7ce0"]])

export default __exports__